<template>
  <div class="demo">
    <div>
      普通input
      <SjInput class="input" placeholder="large" size="large" v-model="value" />
      <SjInput
        class="input"
        placeholder="middle"
        size="middle"
        v-model="value"
      />
      <SjInput
        class="input"
        placeholder="default"
        size="default"
        v-model="value"
      />
      <SjInput class="input" placeholder="small" size="small" v-model="value" />
      <SjInput class="input" placeholder="mini" size="mini" v-model="value" />
    </div>
    <div>
      含边框
      <SjInput
        class="input"
        placeholder="large"
        border
        size="large"
        v-model="value"
      />
      <SjInput
        class="input"
        placeholder="middle"
        border
        size="middle"
        v-model="value"
      />
      <SjInput
        class="input"
        placeholder="default"
        border
        size="default"
        v-model="value"
      />
      <SjInput
        class="input"
        placeholder="small"
        border
        size="small"
        v-model="value"
      />
      <SjInput
        class="input"
        placeholder="mini"
        border
        size="mini"
        v-model="value"
      />
    </div>
    <div>
      配置左右padding
      <SjInput
        class="input"
        border
        placeholder="配置padding"
        :padding="30"
        v-model="value"
      />
    </div>
    <div>
      深色模式<SjInput
        class="input"
        placeholder="深色"
        dark
        v-model="value"
        style="background: black"
      />
    </div>
    <div>
      readonly<SjInput
        class="input"
        placeholder="readonly"
        readonly
        v-model="value"
      />
    </div>
    <div>
      禁用状态<SjInput
        class="input"
        placeholder="禁用"
        disabled
        v-model="value"
      />
    </div>
    <div>
      深色禁用状态<SjInput
        class="input"
        placeholder="深色禁用"
        dark
        disabled
        style="background: black"
        v-model="value"
      />
    </div>
    <div>
      focus状态(需要边框)<SjInput
        class="input"
        placeholder="placeholder"
        border
        isFocus
        v-model="value"
      />
    </div>
    <div>
      error状态(需要边框)<SjInput
        class="input"
        placeholder="placeholder"
        border
        isError
        v-model="value"
      />
    </div>
    <div>
      textarea模式
      <SjInput
        class="input"
        placeholder="textarea"
        textArea
        border
        size="large"
        style="height: 100px;"
        v-model="value"
      />
    </div>
    <div>
      file模式<SjInput
        class="input"
        border
        placeholder="placeholder"
        v-model="file"
        type="file"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",
      file: null
    };
  }
};
</script>

<style scoped lang="less">
.demo {
  > * {
    display: flex;
    align-items: center;

    + * {
      margin-top: 20px;
      .input {
        margin-left: 20px;
        width: 180px;
      }
    }
  }
}
</style>
